// Display formatting for the Tol (+) / Tol (−) columns.
//
// Stored convention (pipeline/rule_engine.py): `tolerance_plus` is the signed
// deviation added to nominal (UCL = nominal + tol_plus) and `tolerance_minus`
// is the magnitude subtracted from nominal (LCL = nominal − tol_minus).
// Display shows the actual deviation sign, so a stored tolerance_minus of 2.4
// renders "-2.4", and a signed tolerance_plus of -0.008 stays "-0.008".

const DASH = '—';

const cleanTol = (v) => {
  if (v === null || v === undefined) return null;
  const s = String(v).trim();
  if (s === '' || s === DASH || s === 'NA' || s === '-') return null;
  if (s.toUpperCase() === 'BASIC') return null;
  return s;
};

export const fmtTolPlus = (v) => {
  const s = cleanTol(v);
  if (s === null) return DASH;
  if (Number.isNaN(parseFloat(s))) return s;
  if (s.startsWith('-')) return s;
  return `+${s.replace(/^\+/, '')}`;
};

export const fmtTolMinus = (v) => {
  const s = cleanTol(v);
  if (s === null) return DASH;
  if (Number.isNaN(parseFloat(s))) return s;
  if (s.startsWith('-')) return `+${s.slice(1)}`;
  return `-${s.replace(/^\+/, '')}`;
};
